'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dTwo$002dFactor$002dAuth$0024 from "./presto.-List-Two-Factor-Auth$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002467 from "./presto.-Presto-Router$$anon$67.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$66() {
  this.bkO = null;
  this.bkG = null;
  this.bkH = false;
  this.bkP = null;
  this.bkQ = false;
  this.bkT = null;
  this.bkM = null;
  this.bkN = false;
  this.bkI = null;
  this.bkJ = false;
  this.bkK = null;
  this.bkL = false;
  this.bkR = false;
  this.bkS = false;
  this.bkO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bkT = "ListTwoFactorAuth";
}
export { $c_Lpresto_PrestoRouter$$anon$66 as $c_Lpresto_PrestoRouter$$anon$66 };
$p = $c_Lpresto_PrestoRouter$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$66;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$66() {
}
export { $h_Lpresto_PrestoRouter$$anon$66 as $h_Lpresto_PrestoRouter$$anon$66 };
$h_Lpresto_PrestoRouter$$anon$66.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bkO;
});
$p.M = (function() {
  if ((!this.bkH)) {
    this.bkG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bkH = true;
  }
  return this.bkG;
});
$p.O = (function() {
  if ((!this.bkQ)) {
    this.bkP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkQ = true;
  }
  return this.bkP;
});
$p.E = (function() {
  return this.bkT;
});
$p.t = (function() {
  if ((!this.bkN)) {
    this.bkM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("url", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bkN = true;
  }
  return this.bkM;
});
$p.N = (function() {
  if ((!this.bkJ)) {
    this.bkI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().gl())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bkJ = true;
  }
  return this.bkI;
});
$p.Q = (function() {
  if ((!this.bkL)) {
    this.bkK = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002467.$c_Lpresto_PrestoRouter$$anon$67();
    this.bkL = true;
  }
  return this.bkK;
});
$p.v = (function() {
  if ((!this.bkS)) {
    this.bkR = false;
    this.bkS = true;
  }
  return this.bkR;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee480) => ((p) => \u03b4scrutinee480.cFA(p)))($j_presto$002e$002dList$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_ListTwoFactorAuth$())));
});
var $d_Lpresto_PrestoRouter$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$66, "presto.PrestoRouter$$anon$66", ({
  OI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$66 as $d_Lpresto_PrestoRouter$$anon$66 };
//# sourceMappingURL=presto.-Presto-Router$$anon$66.js.map
